import { Component } from '@angular/core';
import { Banner } from '../banner/banner';
import { Partners } from '../partners/partners';
import { StaticText } from '../static-text/static-text';
import { ExploreSection } from '../explore-section/explore-section';
import { FaqSection } from '../faq-section/faq-section';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
@Component({
  selector: 'app-landing-home',
  standalone: true,
  imports: [
    Banner,
    Partners,
    StaticText,
    ExploreSection,
    FaqSection,
    FooterComponent,
  ],
  templateUrl: './landing-home.html',
  styleUrl: './landing-home.scss',
})
export class LandingHome {}
